import styled from 'styled-components';

const WarningMessage = styled.p`
  background-color: rgba(255, 0, 0, 0.5);
  padding: 10px;
  margin: 7px 0px;
  display: inline-block;
  border-radius: 5px;
  position: fixed;
  bottom: 25px;
  right: 25px;
  z-index: 100;
`;

export default WarningMessage;
